const API_BASE = '/api';

async function alliesFetch(path) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
    });
    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      throw new Error(`Error del servidor (${res.status})`);
    }
    if (!data.success) throw new Error(data.error || 'Error del servidor');
    return data.data;
  } finally {
    clearTimeout(timeout);
  }
}

export const fetchAllies = () =>
  alliesFetch('/allies').then((d) => d.allies);

export const fetchAlly = (identifier) =>
  alliesFetch(`/ally/${encodeURIComponent(identifier)}`);
